import './../index.css'

import clsx from 'clsx'
import React from 'react'

const ImageRecommendationsButton = ({
  disabled,
  onClick,
}: {
  disabled?: boolean
  onClick: (...args: Array<any>) => any
}): React.ReactElement<'span'> => {
  return (
    <span
      className={clsx('ImageRecommendationsButton', 'text-link', {
        'text-link--disabled': disabled,
      })}
      onClick={disabled ? undefined : onClick}
    >
      Image recommendations
    </span>
  )
}

export default ImageRecommendationsButton
